import validate from "/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import language_45global from "/build/middleware/language.global.ts";
import listing_45pages_45global from "/build/middleware/listingPages.global.ts";
import quote_45global from "/build/middleware/quote.global.ts";
import route_45guard_45global from "/build/middleware/routeGuard.global.ts";
export const globalMiddleware = [
  validate,
  language_45global,
  listing_45pages_45global,
  quote_45global,
  route_45guard_45global
]
export const namedMiddleware = {
  "checkout-success-page": () => import("/build/middleware/checkoutSuccessPage.ts")
}